import 'react-multi-carousel/lib/styles.css';

import { useInView } from 'framer-motion';
import { forwardRef, useEffect, useRef, useState } from 'react';
import type {
  ArrowProps,
  ButtonGroupProps,
  CarouselProps,
  DotProps,
  ResponsiveType,
} from 'react-multi-carousel';
import Carousel from 'react-multi-carousel';

import { RESPONSIVE_DATA } from './constants';

export type { DotProps };
export type { ResponsiveType };
export type { ArrowProps };
export type { ButtonGroupProps };

export interface MultiCarouselProps extends CarouselProps {
  readonly autoPlayWhenVisible?: boolean;
}

export const MultiCarousel = forwardRef<Carousel, MultiCarouselProps>(
  function MultiCarousel(
    {
      autoPlayWhenVisible = false,
      responsive = RESPONSIVE_DATA,
      children,
      ...props
    }: MultiCarouselProps,
    ref,
  ) {
    const [autoPlayInView, setAutoPlayInView] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    const isInView = useInView(containerRef);

    useEffect(() => {
      if (isInView) {
        setAutoPlayInView(true);
      } else {
        setAutoPlayInView(false);
      }
    }, [autoPlayInView, isInView]);

    const autoPlay =
      props.autoPlay && autoPlayWhenVisible ? autoPlayInView : props.autoPlay;

    return (
      <div ref={containerRef} className="h-full">
        <Carousel
          autoPlay={autoPlay!}
          responsive={responsive}
          ref={ref}
          {...props}
        >
          {children}
        </Carousel>
      </div>
    );
  },
);

export default MultiCarousel;
